import { render } from "./SideNav.vue?vue&type=template&id=12c8b4bf&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=12c8b4bf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-12c8b4bf"

export default script